<ngx-select [allowClear]="false" [items]="visibleItems" optionValueField="value" optionTextField="name"
    [disabled]="ngxDisabled" [(ngModel)]="zone" placeholder="Seleccionar Zona" (select)="changeMarket($event)">

    <ng-template ngx-select-option-not-found let-input>
        "{{input}}" no encontrada
    </ng-template>

</ngx-select>